<template>
    <div class="wrapper">
        <loader></loader>
        <pwa-update></pwa-update>
        <notifications></notifications>
        <page-content></page-content>
    </div>
</template>

<script>
    import PageContent from './parts/Content';
    import PwaUpdate from '../pwa/components/PwaUpdate'

    export default {
        components: {
            PageContent, PwaUpdate
        }
    };
</script>
